module.exports = __webpack_public_path__ + "img/86003407.e0b8aef4.png";